const TextFeatureList = ["disconnection", "repetition", "polarity", "subjectivity", "alliteration", "rhyme"];

// find all substrings in string
function find_allsubstrings(str, substr) { /* eslint-disable-line */
    let indices = [];
    let startIndex = 0;
    while (str.indexOf(substr, startIndex) > -1) {
        let index = str.indexOf(substr, startIndex);
        indices.push(index);
        startIndex = index + substr.length;
    }
    return indices;
}

// threshold configuration
let speechTh = 1.5;
let volTh = 1.1;
let pitchTh = 1.1;
let pauseTh = 0.5;
let disconTh = 0.5; /* eslint-disable-line */
let repTh = 0.5; /* eslint-disable-line */
let subjTh = 0.5; /* eslint-disable-line */
let polTh = 0.5; /* eslint-disable-line */

// recal humour skills (text & audio)
function extractHumorskills(sentence, segment, featureThs) {
    let sentence_string = sentence["sentence"].toLowerCase(); /* eslint-disable-line */
    let sentence_tokens = [];
    let segStartOffset = segment["startOffset"];
    let senStartOffset = sentence["startOffset"];

    // console.log("global config:", featureThs);
    let speechTh = featureThs["speed"];
    let volTh = featureThs["volume"];
    let pitchTh = featureThs["pitch"];
    let pauseTh = featureThs["speed"];
    let disconTh = featureThs["pause"];
    let repTh = featureThs["repetition"];
    let subjTh = featureThs["subjectivity"];
    let polTh = featureThs["polarity"];

    sentence["structure"]["tokens"].map(function(t) {
        sentence_tokens.push({
            "idx": t["idx"],
            "text": t["text"],
            "texthumour": {
                "disconnection": [],
                "repetition": [],
                "polarity": [],
                "subjectivity": [],
                "alliterations": [],
                "rhymes": []
            },
            "audiohumour": [],
        });
    });

    // --- text humour ---
    // incongruity
    if (sentence.hasOwnProperty("incongruity")) {
        // disconnection score
        if (sentence["incongruity"]["word2vec"].hasOwnProperty("disconnection")) {
            let discon = sentence["incongruity"]["word2vec"]["disconnection"];

            if (discon["synscore"] < disconTh) {
                // --- 
                // update disconnection word pair caculation
                // ---
                let disconword0 = discon["wordpairs"][0];
                let disconword1 = discon["wordpairs"][1];
                let wrd0indexs = find_allsubstrings(sentence_string, disconword0.toLowerCase());
                let wrd1indexs = find_allsubstrings(sentence_string, disconword1.toLowerCase());
                if (wrd0indexs.length > 0 && wrd1indexs.length > 0) {
                    let wrd0index = wrd0indexs[0];
                    let wrd1index = wrd1indexs[0];
                    // sentence
                    sentence_tokens.map(function(t, ti) {
                        if (t["idx"] == wrd0index || t["idx"] == wrd1index) {
                            sentence_tokens[ti]["texthumour"]["disconnection"].push(discon["synscore"]);
                        }
                    })

                }
            }
        }

        if (sentence["incongruity"]["word2vec"].hasOwnProperty("repetition")) {
            // repetition score
            let rep = sentence["incongruity"]["word2vec"]["repetition"]
            if (rep["synscore"] > repTh) {
                rep["wordpairs"].map(function(w) {
                    let wrdindexs = find_allsubstrings(sentence_string, w.toLowerCase());
                    wrdindexs.map(function(widx) {
                        sentence_tokens.map(function(t, ti) {
                            if (t["idx"] == widx) {
                                sentence_tokens[ti]["texthumour"]["repetition"].push(rep["synscore"]);
                            }
                        });
                    });
                });
            }
        }
    }

    // --- human centeredness
    if (sentence.hasOwnProperty("interpersonal")) {
        // polarity
        if (sentence["interpersonal"].hasOwnProperty("wPolarity")) {
            sentence["interpersonal"]["wPolarity"]["words"].map(function(w, wi) {
                let wrdindexs = find_allsubstrings(sentence_string, w.toLowerCase());
                wrdindexs.map(function(widx) {
                    sentence_tokens.map(function(t, ti) {
                        if (t["idx"] == widx) {
                            let currPol = sentence["interpersonal"]["wPolarity"]["score"][wi];
                            // console.log("this word polarity:", currPol);
                            if (Math.abs(currPol) >= polTh) {
                                sentence_tokens[ti]["texthumour"]["polarity"].push(currPol);
                            }
                        }
                    });
                });
            });
        }
        // subjectivity
        if (sentence["interpersonal"].hasOwnProperty("wSubjectivity")) {
            sentence["interpersonal"]["wSubjectivity"]["words"].map(function(w, wi) {
                let wrdindexs = find_allsubstrings(sentence_string, w.toLowerCase());
                wrdindexs.map(function(widx) {
                    sentence_tokens.map(function(t, ti) {
                        if (t["idx"] == widx) {
                            let currSubj = sentence["interpersonal"]["wSubjectivity"]["score"][wi];
                            if (Math.abs(currSubj) >= subjTh) {
                                sentence_tokens[ti]["texthumour"]["subjectivity"].push(currSubj);
                            }
                        }
                    });
                });
            });

        }
    }

    // --- phonetic style
    if (sentence.hasOwnProperty("phonetic")) {
        // polarity
        if (sentence["phonetic"].hasOwnProperty("alliterations")) {
            // --- calculate average word length for alliterations
            // let alliterationids = [];
            sentence["phonetic"]["alliterations"].map(function(words) {
                let wordNum = 0;
                words.map(function(w) {
                    wordNum = w[0].toLowerCase().length
                });
                // console.log("avg. words num for alliterations:", wordNum / words.length);
                // ---if avg. word num for alliterations exceeds some thresholds then keep them
                if (wordNum / words.length >= 3) {
                    words.map(function(w) {
                        let wrdindexs = find_allsubstrings(sentence_string, w[0].toLowerCase());
                        wrdindexs.map(function(widx) {
                            sentence_tokens.map(function(t, ti) {
                                if (t["idx"] == widx) {
                                    sentence_tokens[ti]["texthumour"]["alliterations"].push(w[1]);
                                }
                            });
                        });
                    })
                }
            });
        }
        // subjectivity
        if (sentence["phonetic"].hasOwnProperty("rhymes")) {
            sentence["phonetic"]["rhymes"].map(function(words) {
                let wordNum = 0;
                words.map(function(w) {
                    wordNum = w[0].toLowerCase().length
                });
                // ---if avg. word num for alliterations exceeds some thresholds then keep them
                if (wordNum / words.length >= 2) {
                    words.map(function(w) {
                        let wrdindexs = find_allsubstrings(sentence_string, w[0].toLowerCase());
                        wrdindexs.map(function(widx) {
                            sentence_tokens.map(function(t, ti) {
                                if (t["idx"] == widx) {
                                    sentence_tokens[ti]["texthumour"]["rhymes"].push(w[1]);
                                }
                            });
                        });
                    })
                }
            });
        }

    }

    // --- audio humour ---

    let senAudioF = sentence["audioFeature"];
    sentence["words"].map(function(w, wi) {
        let wordAF = w["audioFeature"];
        let wordidx = w["startOffset"] - segStartOffset - senStartOffset;
        let tokenIdx = -1; // handle abnormal value
        sentence_tokens.map(function(t, ti) {
            if (t["idx"] == wordidx) {
                tokenIdx = ti;
            }
        })
        if (tokenIdx != -1) {

            // --- volume
            // --- louder
            if (wordAF["wVOL"]["mean"] > volTh * senAudioF["sVOL"]["mean"] || wordAF["wVOL"]["mean"] > senAudioF["sVOL"]["mean"] + senAudioF["sVOL"]["std"]) {

                if (wi >= 1) {
                    if (wordAF["wVOL"]["mean"] > volTh * sentence["words"][wi - 1]["audioFeature"]["wVOL"]["mean"] || wordAF["wVOL"]["mean"] > sentence["words"][wi - 1]["audioFeature"]["wVOL"]["mean"] + senAudioF["sVOL"]["std"]) {
                        sentence_tokens[tokenIdx]["audiohumour"].push("louder");
                    }
                } else {
                    sentence_tokens[tokenIdx]["audiohumour"].push("louder");
                }
            }
            // --- softer
            if (wordAF["wVOL"]["mean"] < senAudioF["sVOL"]["mean"] / volTh || wordAF["wVOL"]["mean"] < senAudioF["sVOL"]["mean"] - senAudioF["sVOL"]["std"]) {
                if (wi >= 1) {
                    if (wordAF["wVOL"]["mean"] < sentence["words"][wi - 1]["audioFeature"]["wVOL"]["mean"] / volTh || wordAF["wVOL"]["mean"] < sentence["words"][wi - 1]["audioFeature"]["wVOL"]["mean"] - senAudioF["sVOL"]["std"]) {
                        sentence_tokens[tokenIdx]["audiohumour"].push("softer");
                    }
                } else {
                    sentence_tokens[tokenIdx]["audiohumour"].push("softer");
                }
            }
            // --- pitch
            // --- stress
            // console.log("wordAF['wPITCH']:",wordAF["wPITCH"],wordAF["wPITCH"].max, wordAF["wPITCH"].mean,senAudioF.sPITCH.mean)
            if (wordAF["wPITCH"]["max"] > pitchTh * senAudioF["sPITCH"]["mean"] | wordAF["wPITCH"]["std"] > pitchTh * senAudioF["sPITCH"]["std"]) {
                if (wi >= 1) {
                    if (wordAF["wVOL"]["mean"] > sentence["words"][wi - 1]["audioFeature"]["wPITCH"]["mean"] | wordAF["wVOL"]["std"] > pitchTh * sentence["words"][wi - 1]["audioFeature"]["wPITCH"]["std"]) {
                        sentence_tokens[tokenIdx]["audiohumour"].push("stress");
                    }
                } else {
                    sentence_tokens[tokenIdx]["audiohumour"].push("stress");
                }
            }
            // --- speed
            // --- faster
            if (w["word"].trim().length > 2) { // filter short words: in, I, me a, etc.
                if (wordAF["wSPM"] > speechTh * senAudioF["sSPM"]) {
                    if (wi >= 1) {
                        if (wordAF["wSPM"] > speechTh * sentence["words"][wi - 1]["audioFeature"]["wSPM"]) {
                            if (["the", "for", "and"].includes(w["word"].trim().toLowerCase()) == false) {
                                sentence_tokens[tokenIdx]["audiohumour"].push("faster");
                            }
                        }
                    } else {
                        if (["the", "for", "and"].includes(w["word"].trim().toLowerCase()) == false) {
                            sentence_tokens[tokenIdx]["audiohumour"].push("faster");
                        }
                    }
                }
                // --- slower
                if (wordAF["wSPM"] < senAudioF["sSPM"] / speechTh) {
                    if (wi >= 1) {
                        if (wordAF["wSPM"] < sentence["words"][wi - 1]["audioFeature"]["wSPM"] / speechTh) {
                            if (["the", "for", "and"].includes(w["word"].trim().toLowerCase()) == false) {
                                sentence_tokens[tokenIdx]["audiohumour"].push("slower");
                            }
                        }
                    } else {
                        if (["the", "for", "and"].includes(w["word"].trim().toLowerCase()) == false) {
                            sentence_tokens[tokenIdx]["audiohumour"].push("slower");
                        }
                    }
                }
            }


            // --- pause
            if (wordAF["wPAUSE"] > pauseTh) {
                sentence_tokens[tokenIdx]["audiohumour"].push(["pause", wordAF["wPAUSE"]]);
            }
        }
    })

    // console.log("sentence tokens:",sentence_tokens);

    return sentence_tokens

}


// textual humour
function extractTextHumor(sentence) {
    let textFeature = {};
    TextFeatureList.map(function(L) {
            textFeature[L] = [];
        })
        // -- incongruity
    if (sentence.hasOwnProperty("incongruity")) {
        // disconnection score
        let discon = sentence["incongruity"]["word2vec"]["disconnection"];
        if (discon["synscore"] < 0.5) {
            textFeature["disconnection"] = discon["wordpairs"];
        }
        // repetition score
        let rep = sentence["incongruity"]["word2vec"]["repetition"]
        if (rep["synscore"] > 0.5) {
            textFeature["repetition"] = rep["wordpairs"];
        }
    }
    // --- human centeredness
    if (sentence.hasOwnProperty("interpersonal")) {
        // polarity
        if (sentence["interpersonal"].hasOwnProperty("wPolarity")) {
            textFeature["polarity"] = sentence["interpersonal"]["wPolarity"];
        }
        // subjectivity
        if (sentence["interpersonal"].hasOwnProperty("wSubjectivity")) {
            textFeature["polarity"] = sentence["interpersonal"]["wSubjectivity"];
        }
    }
    // --- phonetic style
    if (sentence.hasOwnProperty("phonetic")) {
        // polarity
        if (sentence["phonetic"].hasOwnProperty("alliterations")) {
            textFeature["alliteration"] = sentence["phonetic"]["alliterations"];
        }
        // subjectivity
        if (sentence["phonetic"].hasOwnProperty("rhymes")) {
            textFeature["rhyme"] = sentence["phonetic"]["rhymes"];
        }
    }
    return textFeature;
}

// audio humour feature
function extractAudioHumor(sentence) {
    let senAudioF = sentence["audioFeature"];
    let wordsAudioF = {
        "volume": {
            "softer": [],
            "louder": [],
        },
        "pitch": {
            "stress": []
        },
        "pause": [],
        "speed": {
            "faster": [],
            "slower": []
        },
    };

    sentence["words"].map(function(w, wi) {
        let wordAF = w["audioFeature"];
        // --- volume
        // --- louder
        if (wordAF["wVOL"]["mean"] > volTh * senAudioF["sVOL"]["mean"] || wordAF["wVOL"]["mean"] > senAudioF["sVOL"]["mean"] + senAudioF["sVOL"]["std"]) {
            if (wi >= 1) {
                if (wordAF["wVOL"]["mean"] > volTh * sentence["words"][wi - 1]["audioFeature"]["wVOL"]["mean"] || wordAF["wVOL"]["mean"] > sentence["words"][wi - 1]["audioFeature"]["wVOL"]["mean"] + senAudioF["sVOL"]["std"]) {
                    wordsAudioF["volume"]["louder"].push([w["word"], w["startOffset"], w["endOffset"]]);
                }
            } else {
                wordsAudioF["volume"]["louder"].push([w["word"], w["startOffset"], w["endOffset"]]);
            }
        }
        // --- softer
        if (wordAF["wVOL"]["mean"] < senAudioF["sVOL"]["mean"] / volTh || wordAF["wVOL"]["mean"] < senAudioF["sVOL"]["mean"] - senAudioF["sVOL"]["std"]) {
            if (wi >= 1) {
                if (wordAF["wVOL"]["mean"] < sentence["words"][wi - 1]["audioFeature"]["wVOL"]["mean"] / volTh || wordAF["wVOL"]["mean"] < sentence["words"][wi - 1]["audioFeature"]["wVOL"]["mean"] - senAudioF["sVOL"]["std"]) {
                    wordsAudioF["volume"]["softer"].push([w["word"], w["startOffset"], w["endOffset"]]);
                }
            } else {
                wordsAudioF["volume"]["softer"].push([w["word"], w["startOffset"], w["endOffset"]]);
            }
        }
        // --- pitch
        // --- stress
        if (wordAF["wPITCH"]["max"] > pitchTh * senAudioF["sPITCH"]["mean"] && wordAF["wPITCH"]["std"] > senAudioF["sPITCH"]["std"]) {
            if (wi >= 1) {
                // if(wordAF["wVOL"]["mean"] > pitchTh * sentence["words"][wi-1]["audioFeature"]["wPITCH"]["mean"]){
                //     wordsAudioF["pitch"]["stress"].push( [w["word"],w["startOffset"],w["endOffset"]]);
                // }
                wordsAudioF["pitch"]["stress"].push([w["word"], w["startOffset"], w["endOffset"]]);
            } else {
                wordsAudioF["pitch"]["stress"].push([w["word"], w["startOffset"], w["endOffset"]]);
            }
        }
        // --- speed
        // --- faster
        if (w["word"].trim().length > 2) { // filter short words: in, I, me a, etc.
            if (wordAF["wSPM"] > speechTh * senAudioF["sSPM"]) {
                if (wi >= 1) {
                    if (wordAF["wSPM"] > speechTh * sentence["words"][wi - 1]["audioFeature"]["wSPM"]) {
                        wordsAudioF["speed"]["faster"].push([w["word"], w["startOffset"], w["endOffset"]]);
                    }
                } else {
                    wordsAudioF["speed"]["faster"].push([w["word"], w["startOffset"], w["endOffset"]]);
                }
            }
            // --- slower
            if (wordAF["wSPM"] < senAudioF["sSPM"] / speechTh) {
                if (wi >= 1) {
                    if (wordAF["wSPM"] < sentence["words"][wi - 1]["audioFeature"]["wSPM"] / speechTh) {
                        wordsAudioF["speed"]["slower"].push([w["word"], w["startOffset"], w["endOffset"]]);
                    }
                } else {
                    wordsAudioF["speed"]["slower"].push([w["word"], w["startOffset"], w["endOffset"]]);
                }
            }
        }



        // --- pause
        if (wordAF["wPAUSE"] > pauseTh) {
            wordsAudioF["pause"].push([w["word"], wordAF["wPAUSE"], w["startOffset"], w["endOffset"]]);
        }


    })

    // console.log("word audio Feature:",wordsAudioF);
    return wordsAudioF;

}
// extract humor skills
function extractWordHumorskills(featuredata) {
    // console.log("feature data in global config:", featuredata);

    let sentences = [];
    featuredata["segments"].map(function(seg, segid) {
            seg["sentences"].map(function(sen, senid) {
                if (sen.hasOwnProperty("startTime")) {
                    let textFeature = extractTextHumor(sen);
                    let audioFeature = extractAudioHumor(sen);
                    sen["humorskills"] = {
                        "text": textFeature,
                        "audio": audioFeature,
                    }
                    sentences.push([sen, senid, segid]);
                }
            })
        })
        // console.log("--- all sentences ---:",sentences);

    return sentences;
}


let textHumorColor = {
    disconnection: '#feb24c',
    repetition: '#3182bd',
    polarity: '#ccebc5',
    subjectivity: '#decbe4',
    alliterations: '#fed9a6',
    rhymes: '#ffffcc'
}

let audioHumorMapping = {
    'softer': 'volume',
    'louder': 'volume',
    'stress': 'pitch',
    'faster': 'speed',
    'slower': 'speed'
}


const audioColor = {
    faster: "#ED6940",
    slower: "#FF903E",

    louder: "#84B13D",
    softer: "#B7CD49",

    pause: "#4387ED",

    // stress
    stress: "#9A86D6",
};

let allTechColor = {
    // --- audio
    faster: "#ED6940",
    slower: "#FF903E",
    // slower: "#ED6940",

    louder: "#84B13D",
    softer: "#B7CD49",

    pause: "#4387ED",

    stress: "#9A86D6",

    // --- text
    disconnection: '#feb24c',
    repetition: '#3182bd',

    // polarity: '#ccebc5',
    polarity: '#538d22',
    subjectivity: '#444b6e',

    alliterations: '#720026',
    rhymes: '#CE4257'

}

let allTechHtmls = {
    // --- audio
    faster: '<i class="fas fa-angle-double-right"></i>',
    slower: '<i class="fas fa-angle-double-left"></i>',
    // slower: "#ED6940",

    louder: '<i class="fas fa-level-up-alt"></i>',
    softer: '<i class="fas fa-level-down-alt"></i>',

    pause: '<i class="fas fa-square"></i>',

    stress: '<i class="fas fa-underline"></i>',

    // --- text
    disconnection: '<i class="fas fa-circle-notch"></i>',
    repetition: '<i class="fas fa-sync-alt"></i>',

    polarity: '<i class="fas fa-arrows-alt-v"></i>',
    subjectivity: '<div style="font-weight:bold">( )</div>',

    alliterations: '<div style="font-weight:bold">A</div>',
    rhymes: '<div style="font-weight:bold">R</div>'

}

let techlegend = {
    faster: '\uf101',
    slower: '\uf100',

    louder: '\uf3bf',
    softer: '\uf3be',

    pause: '\uf0c8',

    stress: '\uf0cd',

    // --- text
    disconnection: '\uf1ce',
    repetition: '\uf2f1',

    polarity: '\uf338',
    subjectivity: '( )',

    alliterations: 'A',
    rhymes: 'R'
}

let techlabels = {
    faster: '\uf101',
    slower: '\uf100',

    louder: '\uf3bf',
    softer: '\uf3be',

    pause: '\uf0c8',

    stress: '\uf0cd',

    // --- text
    disconnection: '\uf1ce',
    repetition: '\uf2f1',

    polarity: '\uf338',
    subjectivity: '( )',

    alliterations: 'A',
    rhymes: 'R'
}

let humorskillsType = ["repetition", "disconnection", "polarity", "subjectivity", "alliterations", "rhymes",
    "louder", "softer", "stress", "pause", "faster", "slower"
]

let textualhumorTypes = ["repetition", "disconnection", "polarity", "subjectivity", "alliterations", "rhymes"]
let audiohumorTypes = ["louder", "softer", "stress", "pause", "faster", "slower"]


let compare = function(x, y) {
    if (x < y) {
        return -1;
    } else if (x > y) {
        return 1;
    } else {
        return 0;
    }
};

function onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
}


export default {
    extractWordHumorskills,
    TextFeatureList,
    extractTextHumor,
    extractAudioHumor,
    extractHumorskills,
    textHumorColor,
    audioHumorMapping,
    audioColor,
    allTechColor,
    techlabels,
    techlegend,
    allTechHtmls,
    humorskillsType,
    compare,
    onlyUnique,
    textualhumorTypes,
    audiohumorTypes,
}